import { WidgetEnv } from "@xapp/stentor-chat-widget";
import { FC, useMemo } from "react";
import { ChatDetail } from "../../store/ChatAction";
import { createStateFromMessages } from "../../store/ChatStaticStore";
import { ChatWidgetMode } from "./ChatWidget";
import StaticChatWidgetContainer from "./StaticChatWidgetContainer";

export interface StaticMessagesChatWidgetContainerProps {
    readonly messages: readonly ChatDetail[];
    readonly mode?: ChatWidgetMode;
    readonly config: Omit<WidgetEnv, "connection">;
    /**
     * Disable automatic scrolling behavior when messages change.
     * Useful for embedded preview contexts where the widget should not
     * affect the parent page's scroll position.
     *
     * @default false
     */
    readonly disableAutoScroll?: boolean;
    /**
     * Enable preview mode to disable input and interactions.
     *
     * @default false
     */
    readonly preview?: boolean;
}

const StaticMessagesChatWidgetContainer: FC<StaticMessagesChatWidgetContainerProps> = (props) => {
    const { messages } = props;

    const state = useMemo(() => {
        return createStateFromMessages(messages);
    }, [messages]);

    return <StaticChatWidgetContainer state={state} mode={props.mode} config={props.config} disableAutoScroll={props.disableAutoScroll} preview={props.preview} />;
};

export default StaticMessagesChatWidgetContainer;
